module.exports = __webpack_public_path__ + "990a1dcea15bf2341305cced0ceaf912.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/servant.png
// module id = 503
// module chunks = 3